import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {tap, map, catchError, share, finalize, switchMap} from 'rxjs/operators';
import {Observable, of, Subject} from 'rxjs';
import {JqueryDialogService} from './ui-components/jquery-dialog/jquery-dialog.service';
import {HttpClient} from '@angular/common/http';
import {AuthService} from 'src/shared/service/auth.service';

declare var myExtObject: any;

@Injectable()
export class AbstractDataProvider {

  private actionUrl: string;
  public baseUrl: string;
  private router: Router;
  private customForm: any;

  public subject = new Subject<any>();
  totalAjaxCallCounter = 0;

  iso8601RegEx = /(19|20|21)\d\d([-/.])(0[1-9]|1[012])\2(0[1-9]|[12][0-9]|3[01])T(\d\d)([:/.])(\d\d)([:/.])(\d\d)/;
  emailRegEx = /(19|20|21)\d\d([-/.])(0[1-9]|1[012])\2(0[1-9]|[12][0-9]|3[01])T(\d\d)([:/.])(\d\d)([:/.])(\d\d)/;

  constructor(private http: HttpClient,
              private authService: AuthService,
              private jqueryDialogService: JqueryDialogService,
              router: Router) {

    this.router = router;

    if (myExtObject.APIUrl) {
      this.baseUrl = myExtObject.APIUrl;
    }
  }

  getDummyObservable() {
    return this.subject.asObservable();
  }

  postData(data: any, url: string, options: any = null): Observable<any> {
    url = this.appendTabLevelInfoToUrl(url);
    const request = of(true)
      .pipe(
        tap(() => {
          this.showLoader(url);
        }),
        switchMap(() => {
          if (options) {
            return this.http.post(this.baseUrl + url, data, options);
          } else {
            return this.http.post(this.baseUrl + url, data);
          }
        }),
        catchError((error, caught) => {
          return this.handleError(error);
        }),
        finalize(() => {
          this.hideLoader(url);
        })
      );
    return request;
  }

  getData(url: string, appendUserInfo: boolean = true): Observable<any> {
    if (appendUserInfo) {
      url = this.appendTabLevelInfoToUrl(url);
    }
    const request = of(true)
      .pipe(
        tap(() => {
          this.showLoader(url);
        }),
        switchMap(() => this.http.get(this.baseUrl + url)),
        catchError((error, caught) => {
          return this.handleError(error);
        }),
        finalize(() => {
          this.hideLoader(url);
        })
      );
    return request;
  }

  appendTabLevelInfoToUrl(url: string): string {
    // Add User type, RecordNum & WpUserNum
    if (this.authService.WpUserNum) {
      let concatenateChar = '?';
      if (url.indexOf('?') >= 0) {
        concatenateChar = '&';
      }
      url += concatenateChar + 'UserNum=' + this.authService.WpUserNum;
    }
    if (this.authService.RecordNum) {
      let concatenateChar = '?';
      if (url.indexOf('?') >= 0) {
        concatenateChar = '&';
      }
      url += concatenateChar + 'RecordNum=' + this.authService.RecordNum;
    }
    if (this.authService.UserType) {
      let concatenateChar = '?';
      if (url.indexOf('?') >= 0) {
        concatenateChar = '&';
      }
      url += concatenateChar + 'UserType=' + this.authService.UserType;
    }

    if (this.authService.PreviousLoggedInUser) {
      if (this.authService.PreviousLoggedInUser.UserType) {
        let concatenateChar = '?';
        if (url.indexOf('?') >= 0) {
          concatenateChar = '&';
        }
        url += concatenateChar + 'ForUserType=' + this.authService.PreviousLoggedInUser.UserType;
      }
      if (this.authService.PreviousLoggedInUser.RecordNum) {
        let concatenateChar = '?';
        if (url.indexOf('?') >= 0) {
          concatenateChar = '&';
        }
        url += concatenateChar + 'ForRecordNum=' + this.authService.PreviousLoggedInUser.RecordNum;
      }
      if (this.authService.PreviousLoggedInUser.WpUserNum) {
        let concatenateChar = '?';
        if (url.indexOf('?') >= 0) {
          concatenateChar = '&';
        }
        url += concatenateChar + 'ForUserNum=' + this.authService.PreviousLoggedInUser.WpUserNum;
      }
    }

    return url;
  }

  appendCurrentUserInfo(url: string): string {
    // Add User type, RecordNum & WpUserNum
    const user = (this.authService.PreviousLoggedInUser || this.authService);
    if (user.WpUserNum) {
      let concatenateChar = '?';
      if (url.indexOf('?') >= 0) {
        concatenateChar = '&';
      }
      url += concatenateChar + 'UserNum=' + user.WpUserNum;
    }
    if (user.RecordNum) {
      let concatenateChar = '?';
      if (url.indexOf('?') >= 0) {
        concatenateChar = '&';
      }
      url += concatenateChar + 'RecordNum=' + user.RecordNum;
    }
    if (user.UserType) {
      let concatenateChar = '?';
      if (url.indexOf('?') >= 0) {
        concatenateChar = '&';
      }
      url += concatenateChar + 'UserType=' + user.UserType;
    }
    return url;
  }

  showLoader(url: string = '') {
    this.totalAjaxCallCounter++;
    if (this.jqueryDialogService.showLoaderForPolling === true && this.totalAjaxCallCounter === 1) {
      this.jqueryDialogService.showBusyLoaderLongPolling();
    } else if (this.totalAjaxCallCounter === 1) {
      this.jqueryDialogService.showBusyLoader();
    }
  }

  hideLoader(url: string = '') {
    this.totalAjaxCallCounter--;
    if (this.totalAjaxCallCounter === 0) {
      this.jqueryDialogService.hideBusyLoader();
    }
  }

  exportGrid(searchManager: any, exportUrl) {
    this.customForm = document.createElement('form');
    const type: any = 'object';
    for (const key in searchManager) {
      this.createArrayAndObjectForm(searchManager[key], key);
    }
    this.customForm.action = this.baseUrl + exportUrl;
    this.customForm.target = '_blank';
    this.customForm.method = 'post';
    // this.customForm.Headers = 'Bearer ' + this.authService.AccessToken;
    document.getElementsByTagName('body')[0].appendChild(this.customForm);
    this.customForm.submit();
    document.getElementsByTagName('body')[0].removeChild(this.customForm);
  }

  createArrayAndObjectForm(data, key) {
    const type: any = 'object';
    if (typeof data === type) {
      for (const subkey in data) {
        const typeofSubkey = typeof data[subkey];
        if (typeofSubkey !== type) {
          const i = document.createElement('input'); // input element, text
          i.setAttribute('type', 'text');
          i.setAttribute('name', key + '[' + subkey + ']');
          i.setAttribute('value', data[subkey]);
          this.customForm.appendChild(i);
        } else {
          this.createArrayAndObjectForm(data[subkey], key + '[' + subkey + ']');
        }
      }
    } else if (data) {
      const i = document.createElement('input'); // input element, text
      i.setAttribute('type', 'text');
      i.setAttribute('name', key);
      i.setAttribute('value', data);
      this.customForm.appendChild(i);
    }
  }

  private handleError(error: any): Promise<any> {//
    // console.error('An error occurred', error); // for demo purposes only
    if (error.status === 401) {
      // this._alertService.error("You are not authorized.Please Login");
      // this.authService.navigateToLogin();
      // return;
    }
    if (error.error && error.error.Message) {
      if (!error.error.InnerException) {
        error.error.InnerException = '';
      }
      // this.jqueryDialogService.openValidationMessageJqueryDialog('<p style=\'font-weight:500;color: #000;\'>' +
      // error.error.Message + '</p><p style=\'font-weight:400;color: #000;\'>' + error.error.InnerException + '</p>');
    }
    return Promise.reject(error);
  }


  private createRequestHeader() {
    const basicOptions = {
      headers:
        {'Access-Control-Allow-Credentials': true}
      ,
      withCredentials: true
    };
    return basicOptions;
  }

  downloadFile(url: string): Observable<any> {
    return this.getData('api/File/GetFileDownloadToken')
      .pipe(map(x => {
        const fileUrl = url + '&AccessToken=' + encodeURIComponent(x.Data);

        const downloadLink = document.createElement('a');
        downloadLink.href = fileUrl;
        downloadLink.setAttribute('download', '');
        downloadLink.setAttribute('target', '_blank');

        document.body.appendChild(downloadLink);
        downloadLink.click();
        downloadLink.remove();
        
        // window.open(this.downloadDocumentImagUrl + posts.DocSeqNum + '&forWhat=form&CurrentUserNumber=' + posts.CurrentUserNumber + '&FileNum=' + FileNum, '_blank');

        return x;
      }));
  }

}
